import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import useFetchActiveUsers from '../../api/useFetchActiveUsers';

/** 「全担当者」を表す sentinel 値（Radix Select は空文字列を許容しないため） */
export const ALL_USERS_VALUE = '__all__';

type Props = {
  /** 選択中の組織ユーザー ID（文字列）または ALL_USERS_VALUE */
  value: string;
  onChange: (value: string) => void;
};

export default function DashboardOrganizationUserSelect({ value, onChange }: Props) {
  const { data: users, isLoading } = useFetchActiveUsers();

  return (
    <div className="w-[236px]">
      <Select value={value} onValueChange={onChange} disabled={isLoading}>
        <SelectTrigger aria-label="担当者で絞り込み" className="h-[42px]">
          <SelectValue placeholder="担当者を選択" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL_USERS_VALUE}>全担当者</SelectItem>
          {users?.records.map((u) => (
            <SelectItem key={u.id} value={String(u.id)}>
              {u.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
